import { isUrlAbsolute } from "../common";
import status from "../constants/actionStatus";

export default (
    state = {
        courses: [],
        courseName: null,
        courseId: null,
        courseProgress: 0,
        showEvaluationTest: false,
        showInstructions: false,
        selfLearningTab: false
    },
    action = {}
) => {
    switch (action.type) {
    case "FILTERED_COURSES_REQUEST":
        return {
            status: status.PENDING,
            courses: [],
        };
    case "FILTERED_COURSES_SUCCESS":
        return {
            status: status.SUCCESS,
            courses: action.payload.map((course) => {
                return {
                    ...course,
                    featuredMobile: isUrlAbsolute(course.featured.thumbnail.jpg)
                        ? course.featured.thumbnail.jpg
                        : '', //we need to see if this is even used.
                };
            }),
        };

    case "FILTERED_COURSES_FAILURE":
        return {
            status: status.ERROR,
            courses: [],
        };
    case "SET_COURSE_NAME":
    return {
        ...state,
        courseName: action.payload,
    };
    case "SET_COURSE_PROGRESS":
    return {
        ...state,
        courseProgress: action.payload,
    };
    case "SET_SHOW_EVALUATION_TEST":
    return {
        showEvaluationTest: action.payload,
    };
    case "SET_SHOW_INSTRUCTIONS":
    return {
        showInstructions: action.payload,
    };
    case "SET_SELF_LEARNING_TAB":
    return {
        selfLearningTab: action.payload,
    };
    case "SET_COURSE_ID":
    return {
        ...state,
        courseId: action.payload,
    };
    case "SET_TEST_DATA":
    return {
        ...state,
        testData: action.payload,
    };
    default:
        return state;
    }
};
